/**
 * Shared Service Constants
 *
 * Centralized configuration for API services to ensure consistency.
 */

// ==================== Pagination ====================

/**
 * Default pagination limit for list endpoints
 * Used by: gallery, library, notifications, invitations
 */
export const DEFAULT_PAGE_LIMIT = 20

/**
 * Larger limit for grid-based views (e.g., image galleries)
 * Shows more items per page to reduce pagination clicks
 */
export const LARGE_PAGE_LIMIT = 30

// ==================== Caching ====================

/**
 * Default stale time for React Query (2 minutes)
 * Data is considered fresh for this duration before refetching
 */
export const DEFAULT_STALE_TIME = 2 * 60 * 1000

/**
 * Default garbage collection time (5 minutes)
 * Unused data is kept in cache for this duration after last use
 */
export const DEFAULT_GC_TIME = 5 * 60 * 1000

/**
 * Short stale time for frequently changing data (30 seconds)
 * Used for: notifications, real-time data
 */
export const SHORT_STALE_TIME = 30 * 1000

/**
 * Public page stale time (5 minutes)
 * Used for: public invitation pages (guests see)
 * Matches CDN max-age of 300s
 */
export const PUBLIC_STALE_TIME = 5 * 60 * 1000

/**
 * Static data stale time (1 day)
 * Used for: greeting presets, templates, other rarely-changing data
 * Matches backend max-age of 86400s
 */
export const STATIC_STALE_TIME = 24 * 60 * 60 * 1000
